import {
  Box,
  Button,
  Divider,
  IconButton,
  LinearProgress,
  MenuItem,
  Pagination,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import { useDeliveryFeeController } from './controller';
import AddIcon from '@mui/icons-material/Add';
import { numberFormat } from '../../utils/nunberFormat';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from 'react-i18next';
import FormDeliveryFee from './Form';
import { DeliveryFeeModel } from '../../models/deliveryFee';
import { FETCH_MORE_DATA_AMOUNT } from '../../config-global';
import { convertDateStringToNormalString } from '../../utils/convertDateFormat';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from '../../components/ConfirmDialog';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';

const DeliveryFee = () => {
  const { t } = useTranslation('global');

  const controller = useDeliveryFeeController();

  return (
    <>
      {controller.openForm ? (
        <FormDeliveryFee
          onClose={controller.handleCloseForm}
          selectedData={controller.selectedData}
          setSelectedData={controller.setSelectedDataState}
          onFetchData={controller.handleFetchData}
        />
      ) : (
        <Box>
          {
            controller.loadingData ?
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingAnimatedIcon />
              </Box>
              :
              <>
                <Typography mb={2} variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
                {t("navbar.Delivery Free management")}
                </Typography>
                <Box mb={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Box>
                    <Button
                      variant="contained"
                      sx={{ textTransform: 'none', background: '#11A2F1', borderRadius: '10px' }}
                      onClick={controller.handleOpenForm}
                    >
                      <AddIcon />
                      &nbsp; {t("navbar.Create Delivery Free")}
                    </Button>
                  </Box>
                </Box>
                <Box>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ background: '#F4F6F8' }}>
                          <TableCell sx={{ borderBottom: 'none' }}>
                            {t("deliveryFee_page.No")}
                          </TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>
                            {t("deliveryFee_page.Area")}
                          </TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>
                            {t("deliveryFee_page.Base Delivery fee")}
                          </TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>
                            {t("deliveryFee_page.Extra Delivery fee")}
                          </TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>
                            {t("navbar.Last Update")}
                          </TableCell>
                          <TableCell sx={{ borderBottom: 'none' }} />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          controller.rows?.map((rows: DeliveryFeeModel, index: number) => {
                            const { id, areaName, basePrice, extraPrice, updatedAt } = rows
                            return (
                              <TableRow key={index}>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {numberFormat(index + 1 + 10 * (controller.currentPage - 1))}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {areaName}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {numberFormat(basePrice)}&nbsp; kip
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {numberFormat(extraPrice)}&nbsp;kip
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {convertDateStringToNormalString(updatedAt)}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }} align="right">
                                  <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, id)}>
                                    <MoreHorizIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            )
                          })
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Divider sx={{ mt: 2, mb: 2 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Pagination color="primary" count={controller.countPagination} onChange={controller.handleChangePage} page={controller.currentPage} />
                  </Box>
                </Box>
                <Popover
                  open={Boolean(controller.openMenu)}
                  anchorEl={controller.openMenu}
                  onClose={controller.handleCloseMenu}
                  anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  PaperProps={{
                    sx: {
                      p: 1,
                      width: 140,
                      '& .MuiMenuItem-root': {
                        px: 1,
                        typography: 'body2',
                        borderRadius: 0.75,
                      },
                    },
                  }}
                >
                  <MenuItem onClick={() => controller.handleOpenEditForm()}>
                    <EditIcon />
                    &nbsp;&nbsp;
                    {t('Edit')}
                  </MenuItem>

                  <MenuItem onClick={() => controller.handleOpenDeleteForm()} sx={{ color: 'error.main' }}>
                    <DeleteIcon />
                    &nbsp;&nbsp;
                    {t('Delete')}
                  </MenuItem>
                </Popover>
                <ConfirmDialog
                  open={controller.openDeleteForm}
                  title='Do you want to delete this Data ?'
                  loading={controller.loadingDeleteButton}
                  onCancel={controller.handleCloseDeleteForm}
                  onConfirm={() => controller.handleDeleteDeliveryFee()}
                />
              </>
          }

        </Box>
      )}
    </>
  );
};
export default DeliveryFee;
